<mp-alert class="maintenance-banner__alert" type="warning">
  <mat-icon class="maintenance-banner__icon" mpAlertIcon>{{ viewModel().icon }}</mat-icon>
  <h4 class="maintenance-banner__title" mpAlertTitle>{{ viewModel().title }}</h4>

  @if (viewModel().announcementText; as announcementText) {
    <!-- Der Text ist das einzige Feld ohne Längengrenze und wird in der Zeile abgeschnitten; ungekürzt
         steht er im Titel-Attribut. -->
    <p class="maintenance-banner__text" [title]="announcementText">{{ announcementText }}</p>
  }

  @if (viewModel().countdown; as countdown) {
    <p class="maintenance-banner__countdown">{{ viewModel().countdownLabel }} {{ countdown }}</p>
  }
</mp-alert>
